module.exports = __webpack_public_path__ + "img/李德毅.1091de63.jpg";